"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useCustomErrorMessagesMapper = function (intl) {
    var getErrorDomain = function (errorPath) {
        var pathArray = errorPath.split('.');
        return pathArray[pathArray.length - 1];
    };
    return react_1.useCallback(function (errors) {
        var _a;
        return (_a = errors) === null || _a === void 0 ? void 0 : _a.map(function (error) {
            var _a;
            switch (error.name) {
                case 'required':
                    error.message = intl.formatMessage({ id: 'label.error.required' });
                    break;
                case 'pattern':
                    switch (getErrorDomain(error.property)) {
                        case 'firstName':
                        case 'lastName':
                            error.message = intl.formatMessage({ id: 'label.error.alphabetic' });
                            break;
                        case 'phone':
                            error.message = intl.formatMessage({ id: 'label.error.telephone' });
                            break;
                        case 'userId':
                            error.message = intl.formatMessage({ id: 'label.error.userId' });
                            break;
                        case 'email':
                            error.message = intl.formatMessage({ id: 'label.error.email' });
                            break;
                        default:
                            error.message = intl.formatMessage({ id: 'label.error.default' });
                            break;
                    }
                    break;
                case 'maxLength':
                    error.message = intl.formatMessage({ id: 'label.error.maxLength' }, { limit: (_a = error.params) === null || _a === void 0 ? void 0 : _a.limit });
                    break;
                default:
                    error.message = intl.formatMessage({ id: 'label.error.default' });
                    break;
            }
            return error;
        });
    }, []);
};
